import { generateUtilityClass, generateUtilityClasses } from '../../styles/classes';
export var dialogTitleComponentName = 'QuantumDialogTitle';
export function getDialogTitleUtilityClass(slot) {
    return generateUtilityClass(dialogTitleComponentName, slot);
}
export var dialogTitleClasses = generateUtilityClasses(dialogTitleComponentName, ['root', 'title', 'closeButton']);
